let lastPageYOffset = null;

export function getBodyScrollbarWidth() {
	return window.innerWidth - document.body.offsetWidth;
}

export function getBodyHeight() {
	return window.innerHeight;
}

export function saveScrollPosition() {
	lastPageYOffset = window.pageYOffset;
}

export function restoreScrollPosition() {
	if (lastPageYOffset !== null) {
		window.scrollTo(window.pageXOffset, lastPageYOffset);
		lastPageYOffset = null;
	}
}